export interface ScoreTrendModel {
  avgScore: number;
  sections: { score: number; sectionId: number; sectionName: string }[];
  studentTestId: number;
  testGroup: number;
  testId: number;
  testName: string;
  testType: string;
  totalScore?: number;
  testTypeId: number;
}

export interface TrendModal {
  trends: ScoreTrendModel[];
  testType: string;
  testTypeId: number;
}

export interface QuestionStatusModal {
  sectionName: string;
  questionStatistics: QuestionStatisticsModal[];
}

export interface QuestionStatisticsModal {
  subTopic: string;
  wrongAnswers: number;
  correctAnswers: number;
  percentile?: number;
}

export const chartColors: string[] = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#44bb74',
];
